import { Button, Paper } from "@mui/material";
import React, {useRef} from "react";
import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import reportsService from "../../../../Service/Reports/reports.service";
import * as yup from "yup";

import ReactToPrint from "react-to-print";
import { pageStyle } from "../../../Print/printPagesStyles";
import ReportPrintTable from "../../reportPrintTable";
import BasicTable from "../../../MUI_components/Table/basicTable";
import supplierService from "Service/Suppliers/supplier.service";
// import Reports from "Components/Print/a4-report-print";
import { currency } from "Components/MUI_components/currencyFormatterTag";

import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { DownloadTableExcel } from "react-export-table-to-excel";
import NestedTable from "Components/MUI_components/Table/nestedTable";
import MultipleTabel from "Components/MUI_components/Table/multipleTable"
import Reports from "../../../../Components/Reports/reports";
import Title from "Components/Card/title";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";


export default function SupplierSummary() {
  const dispatch = useDispatch();
  const [data, setData] = React.useState({
    rows: [],
    cashPayment:[],
    chequePayment:[],
    cardPayment:[],
    bankPayment:[],
    returnAmount:[],
    purchaseReturnAmount:[],
    supplier: null,
    fromDate: "",
    toDate: "",
    loading: false,
  });
  const componentRef = React.createRef();



   const totalReturn = data.rows
   .map((props) => parseFloat(props["source"] == "RTN" ? props["amount"] : 0))
   .reduce((sum, i) => sum + i, 0);   
   
const cashTotal =  data.cashPayment.map(row=> row.cashTotal);
const chequeTotal = data.chequePayment.map(row => Number(row.chequeTotal)).reduce((sum, value) => sum + value, 0);
const cardTotal = data.cardPayment.map(row=>row.cardTotal);
const bankDeposit = data.bankPayment.map(row=>row.bankTotal);
const returnReceipt = data.purchaseReturnAmount.map(row=>row.purchaseReturnTotal);
const purchaseReturnAmount = data?.supplier?.returnAmount;




const totalpayment =parseFloat(cashTotal[0] ? cashTotal[0]  : 0 ) + parseFloat(chequeTotal ? chequeTotal :0) + parseFloat(cardTotal[0] ? cardTotal[0] : 0) + parseFloat (bankDeposit[0] ? bankDeposit[0] :0) ; 

const lastTotal = currency(totalpayment - totalReturn)

  const sourceName = (val) => {
    switch (val) {
      case "GRN":
        return "GRN";
      case "RTN":
        return "Puchase Return";
      case "PMT":
        return "Payments";
      default:
        return "";
    }
  };
  const tableRef = useRef(null);
  const HeadCells = [
    {
      key: (val) => {
        return (
          <>
            {sourceName(val["source"])}
            <br />
            <span style={{ fontSize: 10 }}>({val["code"]})</span>
          </>
        );
      },
      align: "left",
      label: COLUMNS_NAME.DESCRIPTION,
    },
    {
      key: (val) => {
        return val["createdAt"];
      },
      align: "left",
      label: COLUMNS_NAME.DATE,
    },
    {
      key: (val) => {
        return val["source"] === "GRN" ? val["amount"] : "";
      },
      currency: true,
      align: "right",
      label: "Debit (-)",
    },
    {
      key: (val) => {
        return val["source"] !== "GRN" ? val["amount"] : "";
      },
      align: "right",
      label: "Credit (+)",
      currency: true,
    },
  ];

const bodyCells = {
  cashPay: cashTotal[0],
  chequePay: chequeTotal,
  cardPay: cardTotal[0],
  bankDeposit:bankDeposit[0],
  returnReceipt: purchaseReturnAmount,
  tatal:lastTotal
}
  const outStanding = data.rows
    .map((props) =>
      parseFloat(props["source"] === "GRN" ? props["amount"] : -props["amount"])
    )
    .reduce((sum, i) => sum + i, 0);
  const billTotal = data.rows
    .map((props) => parseFloat(props["source"] === "GRN" ? props["amount"] : 0))
    .reduce((sum, i) => sum + i, 0);
  const paidTotal = data.rows
    .map((props) => parseFloat(props["source"] !== "GRN" ? props["amount"] : 0))
    .reduce((sum, i) => sum + i, 0);

  
  const handleSubmit = async (values) => {
    setData({
      ...data,
      loading: true,
    });
    const { supplier, fromDate, toDate } = values;
    try {
      const res = await reportsService.supplierSummary(
        supplier.code,
        fromDate.toString(),
        toDate.toString()
      );
     
      const filteredRows = res.supplierSummary.filter(row => row.source !== "RTN");

      setData({
        loading: false,
        rows: filteredRows,
        cashPayment:res.cashPayment,
        chequePayment:res.chequePayment,
        cardPayment:res.cardPayment,
        bankPayment:res.bankPayment,
        returnAmount:res.returnAmount,
        purchaseReturnAmount:res.purchaseReturnAmount,
        supplier:res.supplier[0],
        fromDate,
        toDate,
      });
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    .toISOString()
    .split("T")[0];
  const today = date.toISOString().split("T")[0];

  const Validation = yup.object({
    supplier: yup.object().required("Supplier is Required").nullable(),
    fromDate: yup.date().required("From Date is Required"),
    toDate: yup.date().required("To Date is Required"),
  });
  
  return (
    <div style={{ display: 'flex', width: '100%' }}>
    <div >
      <Reports />
    </div>
    <div style={{width: '100%'}}>
      <Formik
        initialValues={{
          supplier: "",
          fromDate: firstDay,
          toDate: today,
        }}
        validationSchema={Validation}
        onSubmit={handleSubmit}
      >
        {(props) => {
          return (
            <Form>
              <Title>Supplier Summary</Title>
              <div className="flex mt mb">
                <div className="col-4">
                <FormControl
                    control="asynchronousAutoComplete"
                    name="supplier"
                    size="small"
                    Service={supplierService}
                    label="Supplier"
                    getOptionLabel={(option) =>
                      option.name +
                      " " +
                      option.code
                    }
                  />
                </div>
                <div className="col-3">
                  <FormControl
                    control="input"
                    type="date"
                    name="fromDate"
                    size="small"
                    label="From"
                    inputProps={{
                      max: today,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="col-3">
                  <FormControl
                    control="input"
                    type="date"
                    name="toDate"
                    size="small"
                    label="To"
                    inputProps={{
                      max: today,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="col-1">
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={props.isSubmitting}
                  >
                    Find
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      <Paper>
        <div className="flex-end">
          <ReactToPrint
            trigger={() => (
              <Button
                style={{ margin: 5 }}
                disabled={!data.rows.length}
                variant="contained"
              >
                Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={pageStyle.a4}
          /> 
             <DownloadTableExcel
            filename="CreditStatement"
            currentTableRef={tableRef.current}
          >
            <Button
              style={{ margin: 5 }}
              disabled={!data.rows.length}
              variant="contained"
            >
              Export to Excel </Button>
          </DownloadTableExcel>
        </div>
        <div style={{ display: "none" }}>
        
            <Reports
             
            >
                <div ref={componentRef} className="printArea">
              <ReportPrintTable
               title={`supplier Summary: ${
                data.supplier?.name + ` - ` + data.supplier?.phone1
              } Location : ${JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).name}`}
                headCells={HeadCells}
                rows={data.rows}
                // lastRow="Outstanding"
                // billTotal={outStanding}
              >
                <tr>
                  <th colSpan={3}></th>
                  <th style={{ backgroundColor: "#cacaca60" }} align="right">
                    {currency(billTotal)}
                  </th>
                  <th align="right" style={{ backgroundColor: "#cacaca60" }}>
                    {currency(paidTotal)}
                  </th>
                </tr>
                <tr>
                  <th colSpan={3}></th>
                  <th style={{ borderTop: "1.5px solid #000" }} align="center">
                    {COLUMNS_NAME.OUTSTANDING}
                  </th>
                  <th style={{ borderTop: "1.5px solid #000" }} align="right">
                    {currency(outStanding)}
                  </th>
                </tr>
              </ReportPrintTable>
              </div>
            </Reports>
          
        </div>

        {/* <BasicTable
          headCells={HeadCells}
          rows={data.rows}
          isLoaded={data.loading}
          tableRef={tableRef}
        /> */}
        <MultipleTabel
        headCells={HeadCells}
        rows={data.rows}
        isLoaded={data.loading}
        tableRef={tableRef}
        bodyCells={bodyCells}
        />
     
      </Paper>
    </div>
    </div>
  );
}